import * as React from 'react';

import { cn } from '@/utils/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      className={cn(
        'mt-1 flex min-h-[80px] w-full rounded-md border border-zinc-300 bg-zinc-100 px-3 py-2 focus-visible:shadow-lg text-xs text-zinc-800 ring-offset-background placeholder:text-zinc-400 focus-visible:outline-none focus-visible:bg-white focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';

export { Textarea };
